import { api } from './api-client';

export interface PlatformAdmin {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  status?: string;
  /** Renvoyé par /whoami seulement (= début de la session courante : mis à jour à chaque MFA réussi). */
  lastLoginAt?: string | null;
  /** Admin créé par un autre admin (mot de passe généré) : changement imposé avant toute autre page (9.6b). */
  mustChangePassword?: boolean;
}

export interface LoginResponse {
  challengeToken: string;
  mfaRequired: true;
}

export interface MfaVerifyResponse {
  accessToken: string;
  admin: PlatformAdmin;
  /** À la racine de la réponse (pas dans admin). */
  mustChangePassword: boolean;
}

export const AUTH_PATHS = {
  login: '/auth/login',
  mfaVerify: '/auth/mfa/verify',
  whoami: '/auth/whoami',
  logout: '/auth/logout',
  backupCodesCount: '/auth/me/backup-codes-count',
  changePassword: '/auth/change-password',
} as const;

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
  mfaCode: string;
}

export const authApi = {
  login: async (email: string, password: string): Promise<LoginResponse> =>
    (await api.post<LoginResponse>(AUTH_PATHS.login, { email, password })).data,
  verifyMfa: async (challengeToken: string, code: string): Promise<MfaVerifyResponse> =>
    (await api.post<MfaVerifyResponse>(AUTH_PATHS.mfaVerify, { challengeToken, code })).data,
  whoami: async (): Promise<PlatformAdmin> => (await api.get<{ admin: PlatformAdmin }>(AUTH_PATHS.whoami)).data.admin,
  backupCodesCount: async (): Promise<number> => (await api.get<{ count: number }>(AUTH_PATHS.backupCodesCount)).data.count,
  changePassword: async (input: ChangePasswordInput): Promise<void> => {
    await api.post(AUTH_PATHS.changePassword, input);
  },
  logout: async (): Promise<void> => {
    await api.post(AUTH_PATHS.logout);
  },
};
